export default {
    methods: {
        parseKidStatusVietnamese (strStatus) {
            switch (strStatus) {
                case "STUDYING":
                    return "Đang học";
                case "STUDY_WAIT":
                    return "Chờ học";
                case "RESERVE":
                    return "Bảo lưu";
                case "LEAVE_SCHOOL":
                    return "Nghỉ học";
                case "OUT_SCHOOL":
                    return "Ra trường";
            }
        }
    }
}